var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97465 0.872749C9.94946 0.811791 9.90674 0.759679 9.85191 0.723009C9.79709 0.686339 9.73261 0.666759 9.66665 0.666749H0.33332C0.267306 0.66663 0.202744 0.686116 0.147817 0.722735C0.0928914 0.759354 0.050075 0.811457 0.0247966 0.87244C-0.000481712 0.933422 -0.00708377 1.00054 0.00582742 1.06528C0.0187386 1.13001 0.0505815 1.18946 0.0973194 1.23608L4.76399 5.90275C4.79495 5.93379 4.83173 5.95842 4.87223 5.97522C4.91273 5.99203 4.95614 6.00068 4.99999 6.00068C5.04383 6.00068 5.08724 5.99203 5.12774 5.97522C5.16824 5.95842 5.20502 5.93379 5.23599 5.90275L9.90265 1.23608C9.94924 1.18943 9.98095 1.13001 9.99376 1.06534C10.0066 1.00066 9.99993 0.933642 9.97465 0.872749Z",
    fill: "#0276B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDropdown);
export default __webpack_public_path__ + "static/media/blueDropdown.b7c148f08054c0b2bf51ebf338d58b71.svg";
export { ForwardRef as ReactComponent };